// extracted by mini-css-extract-plugin
module.exports = {"active":"CheckboxCard-module--active--sxcjO","svgCheckboxContainer":"CheckboxCard-module--svg-checkbox-container--2aE9F"};